<template>
    <div>
        <v-list class="px-3"  style="max-width: 270px;">
            <v-list-item>
                <v-list-item-title style="font-weight: bold;"> {{ $t('yego_dashboard.settings') }} </v-list-item-title>
            </v-list-item>
        
            <v-list-item>
                <v-list-item-title>{{ $t('yego_dashboard.efficiency_criterion') }}</v-list-item-title>
            </v-list-item>

            <v-list-item class="my-1">
                <v-row justify="start" align="center" class="px-5">
                    <v-col cols="1" class="py-0 my-0 px-0">
                        <v-icon color="success2" small>circle</v-icon>
                    </v-col>
                    <v-col cols="6" elevation="2" class="py-0 my-0 ml-3">
                        <v-row justify="start" align="center" class="py-0 my-0 px-0">
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 35px;">
                                <v-text-field solo text class="range_input" v-model="buyout_options.green.min" ref="green_min"/>
                            </v-col>
                            <v-col cols="1" class="py-0 my-0 px-0" style="text-align: center;">-</v-col>
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 35px;">
                                <v-text-field solo text class="range_input" v-model="buyout_options.green.max" ref="green_max"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-list-item>

            <v-list-item class="my-1">
                <v-row justify="start" align="center" class="px-5">
                    <v-col cols="1" class="py-0 my-0 px-0">
                        <v-icon color="red" small>circle</v-icon>
                    </v-col>
                    <v-col cols="6" class="py-0 my-0 ml-3">
                        <v-row justify="start" align="center" class="py-0 my-0 px-0">
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 30px;">
                                <v-text-field solo text class="range_input" v-model="buyout_options.red.min" ref="red_min"/>
                            </v-col>
                            <v-col cols="1" class="py-0 my-0 px-0" style="text-align: center;">-</v-col>
                            <v-col cols="5" class="py-0 my-0 px-0" style="max-height: 30px;">
                                <v-text-field solo text class="range_input px-0 mx-0" v-model="buyout_options.red.max" ref="red_max"/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                
            </v-list-item>
            <v-list-item>
                <v-row justify="center" align="center">
                    <v-col cols="12" justify="center" align="center">
                        <v-btn color="secondary" small outlined style="min-width: 100%;" @click="emitValue()">{{ $t('yego_dashboard.update_options') }}</v-btn>
                    </v-col>
                </v-row>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>

export default {
    props: [
        'buyout_options'
    ],
    data(){
        return {}
    },
    mounted(){
    },
    methods: {
        emitValue() {
            this.$emit('buyout_options', this.buyout_options);
        }
    },
    watch: {}
}
</script>

<style>

</style>